/**
 * @Date:   2018-01-23T17:15:23+08:00
 * @Last modified time: 2018-01-26T14:46:57+08:00
 */
import _util from '../../utils/';

const userManagementService = {
    fetchUserList(params, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchUserInit(resolve, reject) {
        _util.request({
            url: '/api/HRUser/Create',
            success: resolve,
            error: reject
        })
    },
    createNewUser(payload, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Post',
            method: 'POST',
            data: payload,
            success: resolve,
            error: reject
        })
    },
    deleteUsers(datas, resolve, reject) {
        _util.request({
            url: '/api/HRUser/MultiDelete',
            method: 'DELETE',
            data: datas,
            success: resolve,
            error: reject
        })
    },
    inactiveUsers(data, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Inactive',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    fetchUserDetail(params, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Details',
            params: params,
            success: resolve,
            error: reject
        })
    },
    updateUserDetail(data, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    resetUsersPassword(data, resolve, reject) {
        _util.request({
            url: '/api/HRUser/ResetPassword',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    handleAuthorize(datas, resolve, reject) {
        _util.request({
            url: '/api/HRUser/Active',
            method: 'PUT',
            data: datas,
            success: resolve,
            error: reject
        })
    },
}

export default userManagementService;



// WEBPACK FOOTER //
// ./src/services/SystemSetting/user-management-service.js